import { NotebookMultipleIcon } from './NotebookMultipleIcon';

/**
 * author: Gabriel Grant
 * id 3F75C3D8-9360-4C31-AF58-1C01321620F0
 * name notebook-multiple
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/notebook-multiple.svg
 * tags
 */
export const PlannerMultipleIcon = NotebookMultipleIcon;
export default PlannerMultipleIcon